import {EntityField} from "./EntityField";
import {EntityFieldMap} from "./EntityFieldMap";
import {Utility} from "../Utility";
import {EntityFieldDataType} from "./EntityFieldDataType";

export const arrayToMap = <T = any>(arr: Array<EntityField<T>>): EntityFieldMap<T> => {
    const map: EntityFieldMap<T> = {};
    arr.forEach((elem: EntityField<T>) => {
        map[elem.name as string] = elem;
    })
    return map;
};

export const getDerivedValue = (fieldName: string, entityFields: Array<EntityField>, item: any): any => {
	for (let entityField of entityFields) {
		if (entityField.dataType == EntityFieldDataType._derived) {
			if (entityField.value) {
				return entityField.value(item)
			}
		}
	}
	return null
}
